import PayableModule from "@/components/PayableModule";
import { ShieldCheck } from "lucide-react";

export default function Contributions() {
  return (
    <PayableModule
      endpoint="contributions"
      title="Cotisations sociales"
      subtitle="CNSS, retraite, assurance maladie… charges sociales"
      icon={ShieldCheck}
      entityLabel="contribution"
      emptyForm={{ type_cotisation: "", periode: "", base_salariale: 0, taux: 0, montant: 0, echeance: "", notes: "" }}
      fields={[
        { key: "type_cotisation", label: "Type de cotisation", type: "select", optionsKey: "contribution_types", required: true, span: 2 },
        { key: "periode", label: "Période (ex: Juin 2026)" },
        { key: "base_salariale", label: "Base salariale (FCFA)", type: "number" },
        { key: "taux", label: "Taux (%)", type: "number" },
        { key: "montant", label: "Montant dû (FCFA)", type: "number", required: true },
        { key: "date", label: "Date", type: "date" },
        { key: "echeance", label: "Échéance", type: "date" },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { label: "Type", render: (r) => <span className="font-semibold">{r.type_cotisation}</span> },
        { label: "Période", render: (r) => <span className="text-sm text-slate-600">{r.periode || "—"}</span> },
        { label: "Base", render: (r) => <span className="text-sm font-mono">{r.base_salariale ? Number(r.base_salariale).toLocaleString("fr-FR") : "—"}</span> },
      ]}
    />
  );
}
